class ConfigureInvoiceTypesDialogController {
  constructor(InvoiceItemType, $mdDialog) {
    this.$mdDialog = $mdDialog;
    this.InvoiceItemType = InvoiceItemType;
    this.requestingTypes = true;
  }

  $onInit() {
    this.model = {
      key: "",
      instances_per_invoice: 1,
      description: "",
    };
    this.InvoiceItemType.queryAll().$promise.then((response) => {
      this.requestingTypes = false;
      this.typeOptions = response;
    });
  }

  confirm() {
    this.$mdDialog.hide(this.model);
  }

  close() {
    this.$mdDialog.cancel();
  }

  $onDestroy() {
    this.close();
  }
}

export default ConfigureInvoiceTypesDialogController;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/configureInvoiceTypesDialog/configureInvoiceTypesDialog.controller.js